import React, { useState } from "react";
import { useDocumentTitle } from "../hooks/useDocumentTitle";
import Section1 from "../components/dashboard/Section1";
import Section2 from "../components/dashboard/Section2";
import Section3 from "../components/dashboard/Section3";
import Section4 from "../components/dashboard/Section4";
import Section5 from "../components/dashboard/Section5";
import Section6 from "../components/dashboard/Section6";
import Section7 from "../components/dashboard/Section7";
import Section8 from "../components/dashboard/Section8";
import Section9 from "../components/dashboard/Section9";
import Section10 from "../components/dashboard/Section10";

import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "animate.css";
import "../assets/vendor/css-hamburgers/hamburgers.min.css";
import "../assets/css/dataTables.bootstrap.min.css";
import "../assets/css/util.css";
import "../assets/css/main.css";
import "../assets/css/style.css";
import "../assets/css/dashboard-custom.css";

import { outboundService } from "../services/outbound.service";
import { serviceLevelPerformanceService } from "../services/serviceLevelPerformance.service";
import { performanceCheckpointService } from "../services/performancecheckpoint.service";
import { avgrevenueService } from "../services/avgrevenue.service";
import { podService } from "../services/Pod.service";
import { costofsalesService } from "../services/costofsales.service";
import { topCustomerService } from "../services/topcustomer.service";

const Dashboard = () => {
  useDocumentTitle("Dashboard Top Management");

  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);

  const [dataByService, setDataByService] = useState<any | null>(null);
  const [dataByDestinationDomestic, setDataByDestinationDomestic] = useState<
    any | null
  >(null);
  const [dataByDestinationIntracity, setDataByDestinationIntracity] = useState<
    any | null
  >(null);
  const [pickupMonthly, setPickupMonthly] = useState<any | null>(null);
  const [deliveryMonthly, setDeliveryMonthly] = useState<any | null>(null);
  const [pickup, setPickup] = useState<any | null>(null);
  const [delivery, setDelivery] = useState<any | null>(null);
  const [deliveryStatusCheckpoints, setDeliveryStatusCheckpoints] = useState<
    any | null
  >(null);
  const [costOfSales, setCostOfSales] = useState<any | null>(null);
  const [timestampCheckpoints, setTimestampCheckpoints] = useState<any | null>(
    null
  );
  const [avgWeightByService, setAvgWeightByService] = useState<any | null>(
    null
  );
  const [avgPiecesByService, setAvgPiecesByService] = useState<any | null>(
    null
  );
  const [avgWeightPerPieces, setAvgWeightPerPieces] = useState<any | null>(
    null
  );
  const [timestampNasional, setTimestampNasional] = useState<any | null>(null);
  const [weeklyPodOSProgress, setWeeklyPodOSProgress] = useState<any[] | null>(
    null
  );
  const [monthlyPodOSProgress, setMonthlyPodOSProgress] = useState<
    any[] | null
  >(null);
  const [petaOutbound, setPetaOutbound] = useState<any | null>(null);
  const [topCustomer, setTopCustomer] = useState<any | null>(null);

  const [isLoadingService, setIsLoadingService] = useState(false);
  const [isLoadingDomestic, setIsLoadingDomestic] = useState(false);
  const [isLoadingIntracity, setIsLoadingIntracity] = useState(false);
  const [isLoadingPickupMonthly, setIsLoadingPickupMonthly] = useState(false);
  const [isLoadingDeliveryMonthly, setIsLoadingDeliveryMonthly] =
    useState(false);
  const [isLoadingPickup, setIsLoadingPickup] = useState(false);
  const [isLoadingDelivery, setIsLoadingDelivery] = useState(false);
  const [isCostOfSalesLoading, setIsCostOfSalesLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState<{
    value: string;
    label: string;
  } | null>({ value: "", label: "NASIONAL" });
  const [isLoadingDSCheckpoints, setIsLoadingDSCheckpoints] = useState(false);
  const [isLoadingTimestampCheckpoints, setIsLoadingTimestampCheckpoints] =
    useState(false);
  const [isLoadingAvgWeightByService, setIsLoadingAvgWeightByService] =
    useState(false);
  const [isLoadingAvgPiecesByService, setIsLoadingAvgPiecesByService] =
    useState(false);
  const [isLoadingAvgWeightPerPieces, setIsLoadingAvgWeightPerPieces] =
    useState(false);
  const [isLoadingTimestampNasional, setIsLoadingTimestampNasional] =
    useState(false);
  const [isLoadingWeeklyPodOSProgress, setIsLoadingWeeklyPodOSProgress] =
    useState(false);
  const [isLoadingMonthlyPodOSProgress, setIsLoadingMonthlyPodOSProgress] =
    useState(false);
  const [isLoadingPetaOutbound, setIsLoadingPetaOutbound] = useState(false);
  const [isLoadingTopCustomer, setIsLoadingTopCustomer] = useState(false);

  const handleSearch = async () => {
    const [startDate, endDate] = dateRange;
    if (!startDate || !endDate) {
      console.warn("Pilih range tanggal dulu");
      return;
    }

    if (!selectedOption) {
      console.warn("Pilih option dulu");
      return;
    }

    const brancId = selectedOption.value;

    const formatDate = (date: Date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    setIsLoadingService(true);
    setIsLoadingDomestic(true);
    setIsLoadingIntracity(true);
    setIsLoadingPickupMonthly(true);
    setIsLoadingDeliveryMonthly(true);
    setIsLoadingPickup(true);
    setIsLoadingDelivery(true);
    setIsLoadingDSCheckpoints(true);
    setIsCostOfSalesLoading(true);
    setIsLoadingTimestampCheckpoints(true);
    setIsLoadingAvgWeightByService(true);
    setIsLoadingAvgPiecesByService(true);
    setIsLoadingAvgWeightPerPieces(true);
    setIsLoadingTimestampNasional(true);
    setIsLoadingWeeklyPodOSProgress(true);
    setIsLoadingMonthlyPodOSProgress(true);
    setIsLoadingPetaOutbound(true);
    setIsLoadingTopCustomer(true);

    setDataByService(null);
    setDataByDestinationDomestic(null);
    setDataByDestinationIntracity(null);
    setPickupMonthly(null);
    setDeliveryMonthly(null);
    setPickup(null);
    setDelivery(null);
    setDeliveryStatusCheckpoints(null);
    setCostOfSales(null);
    setTimestampCheckpoints(null);
    setAvgWeightByService(null);
    setAvgPiecesByService(null);
    setAvgWeightPerPieces(null);
    setTimestampNasional(null);
    setWeeklyPodOSProgress(null);
    setMonthlyPodOSProgress(null);
    setPetaOutbound(null);
    setTopCustomer(null);

    outboundService
      .getOutboundsByService(
        formatDate(startDate),
        formatDate(endDate),
        brancId
      )
      .then(setDataByService)
      .catch(console.error)
      .finally(() => setIsLoadingService(false));

    outboundService
      .getOutboundsByDestinationDomestic(
        formatDate(startDate),
        formatDate(endDate),
        brancId
      )
      .then(setDataByDestinationDomestic)
      .catch(console.error)
      .finally(() => setIsLoadingDomestic(false));

    outboundService
      .getOutboundsByDestinationIntracity(
        formatDate(startDate),
        formatDate(endDate),
        brancId
      )
      .then(setDataByDestinationIntracity)
      .catch(console.error)
      .finally(() => setIsLoadingIntracity(false));

    outboundService
      .getPetaOutbound(formatDate(startDate), formatDate(endDate), brancId)
      .then(setPetaOutbound)
      .catch(console.error)
      .finally(() => setIsLoadingPetaOutbound(false));

    costofsalesService
      .getCostOfSales(brancId)
      .then(setCostOfSales)
      .catch(console.error)
      .finally(() => setIsCostOfSalesLoading(false));

    serviceLevelPerformanceService
      .getpickupServiceLevelPerformanceMonthly(brancId, formatDate(endDate))
      .then(setPickupMonthly)
      .catch(console.error)
      .finally(() => setIsLoadingPickupMonthly(false));

    serviceLevelPerformanceService
      .getdeliveryServiceLevelPerformanceMonthly(brancId, formatDate(endDate))
      .then(setDeliveryMonthly)
      .catch(console.error)
      .finally(() => setIsLoadingDeliveryMonthly(false));

    serviceLevelPerformanceService
      .getpickupServiceLevelPerformance(
        formatDate(startDate),
        formatDate(endDate),
        brancId
      )
      .then(setPickup)
      .catch(console.error)
      .finally(() => setIsLoadingPickup(false));

    serviceLevelPerformanceService
      .getdeliveryServiceLevelPerformance(
        formatDate(startDate),
        formatDate(endDate),
        brancId
      )
      .then(setDelivery)
      .catch(console.error)
      .finally(() => setIsLoadingDelivery(false));

    performanceCheckpointService
      .getPerformanceDSCheckpoints(brancId, formatDate(endDate))
      .then(setDeliveryStatusCheckpoints)
      .catch(console.error)
      .finally(() => setIsLoadingDSCheckpoints(false));

    performanceCheckpointService
      .getPerformanceTimestampCheckpoints(brancId, formatDate(endDate))
      .then(setTimestampCheckpoints)
      .catch(console.error)
      .finally(() => setIsLoadingTimestampCheckpoints(false));

    avgrevenueService
      .avgWeightByService(brancId, formatDate(endDate))
      .then(setAvgWeightByService)
      .catch(console.error)
      .finally(() => setIsLoadingAvgWeightByService(false));

    avgrevenueService
      .avgPiecesByService(brancId, formatDate(endDate))
      .then(setAvgPiecesByService)
      .catch(console.error)
      .finally(() => setIsLoadingAvgPiecesByService(false));

    avgrevenueService
      .avgWeightPerPieces(brancId, formatDate(endDate))
      .then(setAvgWeightPerPieces)
      .catch(console.error)
      .finally(() => setIsLoadingAvgWeightPerPieces(false));

    performanceCheckpointService
      .getTimestampNasional(brancId, formatDate(endDate))
      .then(setTimestampNasional)
      .catch(console.error)
      .finally(() => setIsLoadingTimestampNasional(false));

    podService
      .weeklyPodOSProgress(brancId)
      .then(setWeeklyPodOSProgress)
      .catch(console.error)
      .finally(() => setIsLoadingWeeklyPodOSProgress(false));

    podService
      .monthlyPodOSProgress(brancId)
      .then(setMonthlyPodOSProgress)
      .catch(console.error)
      .finally(() => setIsLoadingMonthlyPodOSProgress(false));

    topCustomerService
      .topCustomers(formatDate(endDate))
      .then(setTopCustomer)
      .catch(console.error)
      .finally(() => setIsLoadingTopCustomer(false));
  };

  return (
    <div className="container-fluid">
      <Section1
        dateRange={dateRange}
        setDateRange={setDateRange}
        handleSearch={handleSearch}
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
      />
      <Section2
        dataByService={dataByService}
        dataByDestinationDomestic={dataByDestinationDomestic}
        dataByDestinationIntracity={dataByDestinationIntracity}
        isLoadingService={isLoadingService}
        isLoadingDomestic={isLoadingDomestic}
        isLoadingIntracity={isLoadingIntracity}
      />
      <Section3
        petaOutbound={petaOutbound}
        isLoadingPetaOutbound={isLoadingPetaOutbound}
      />
      <Section4
        pickupMonthly={pickupMonthly}
        deliveryMonthly={deliveryMonthly}
        isLoadingPickupMonthly={isLoadingPickupMonthly}
        isLoadingDeliveryMonthly={isLoadingDeliveryMonthly}
      />
      <Section5
        pickup={pickup}
        delivery={delivery}
        isLoadingPickup={isLoadingPickup}
        isLoadingDelivery={isLoadingDelivery}
      />
      <Section6
        costOfSales={costOfSales}
        isCostOfSalesLoading={isCostOfSalesLoading}
      />
      <Section7
        deliveryStatusCheckpoints={deliveryStatusCheckpoints}
        timestampCheckpoints={timestampCheckpoints}
        isLoadingDSCheckpoints={isLoadingDSCheckpoints}
        isLoadingTimestampCheckpoints={isLoadingTimestampCheckpoints}
        avgWeightByService={avgWeightByService}
        avgPiecesByService={avgPiecesByService}
        avgWeightPerPieces={avgWeightPerPieces}
        isLoadingAvgWeightByService={isLoadingAvgWeightByService}
        isLoadingAvgPiecesByService={isLoadingAvgPiecesByService}
        isLoadingAvgWeightPerPieces={isLoadingAvgWeightPerPieces}
      />
      <Section8
        timestampNasional={timestampNasional}
        isLoadingTimestampNasional={isLoadingTimestampNasional}
        weeklyPodOSProgress={weeklyPodOSProgress}
        isLoadingWeeklyPodOSProgress={isLoadingWeeklyPodOSProgress}
        monthlyPodOSProgress={monthlyPodOSProgress}
        isLoadingMonthlyPodOSProgress={isLoadingMonthlyPodOSProgress}
      />
      <Section9
        topCustomer={topCustomer}
        isLoadingTopCustomer={isLoadingTopCustomer}
      />
      <Section10
        topCustomer={topCustomer}
        isLoadingTopCustomer={isLoadingTopCustomer}
      />
    </div>
  );
};

export default Dashboard;
